export default __webpack_public_path__ + "static/media/DuskBreakers-logo-kit-v1.b4ff336c.zip";